import assign from 'object-assign';

function hasParent( e, p ) {
    if ( !e ) {
        return false;
    }
    var el = e.target || e.srcElement || e || false;
    while ( el && el != p ) {
        el = el.parentNode || false;
    }
    return (el !== false);
}

function isElement( o ) {
    return (
        typeof HTMLElement === 'object' ? o instanceof HTMLElement : //DOM2
            o && typeof o === 'object' && o !== null && o.nodeType === 1 && typeof o.nodeName === 'string'
    );
}

function textContent( el, value ) {

    if ( !el ) {
        console.error( `"el" param is not defined` );
        return;
    }
    var supports = typeof el.textContent !== 'undefined',
        hasVal = typeof value !== 'undefined';

    if ( supports ) {
        return (hasVal) ? el.textContent = value : el.textContent;
    }
    else {
        return (hasVal) ? el.innerText = value : el.innerText;
    }
}

/**
 * SelectMenu function
 */
function SelectMenu( el, options ) {
    this.el = el;
    this.options = assign( {}, this.options, options );
    this._init();
}

/**
 * SelectMenu options
 */
SelectMenu.prototype.options = {
    // if true all the links will open in a new tab.
    // if we want to be redirected when we click an option, we need to define a data-link attr on the option of the native select element
    newTab: true,
    // when opening the select element, the default placeholder (if any) is shown
    stickyPlaceholder: true,
    // always show placeholder as selected option
    permanentPlaceholder: false,
    // callback when changing the value
    onChange: function ( val ) {
        return false;
    }
};

SelectMenu.prototype._init = function () {
    this.selEl = document.createElement( 'div' );
    this.selEl.className = this.el.className;
    this.selEl.tabIndex = this.el.tabIndex;

    this._buildMenu();
};

SelectMenu.prototype._buildMenu = function () {
    // check if we are using a placeholder for the native select box
    // we assume the placeholder is disabled and selected by default
    var selectedOpt = $( this.el ).find( 'option[selected]' )[0];
    this.hasDefaultPlaceholder = selectedOpt && selectedOpt.disabled;
    // get selected option (either the first option with attr selected or just the first option)
    this.selectedOpt = selectedOpt || this.el.querySelector( 'option' );
    this.selOpts = [];
    // create structure
    this._createSelectEl();
    this.selOpts = $( this.selEl ).find( 'li[data-option]' ).toArray();
    this.current = this.selOpts.indexOf( this.selEl.querySelector( 'li.cs-selected' ) ) || -1;
    this.selPlaceholder = this.selEl.querySelector( 'span.cs-placeholder' );
    this._initEvents();
}

/**
 * creates the structure for the select element
 */
SelectMenu.prototype._createSelectEl = function () {
    var self = this,
        options = '';

    $( this.el ).children().each( function ( i, el ) {
        if ( el.disabled || !isElement( el ) ) {
            return;
        }

        var tag = el.tagName.toLowerCase();

        if ( tag === 'option' ) {
            options += self.createOption( el );
        }
        else if ( tag === 'optgroup' ) {
            options += '<li class="cs-optgroup"><span class="cs-optgroup-label">' + el.label + '</span><ul>';
            $( el ).children().each( function ( i, opt ) {
                if ( isElement( opt ) ) {
                    options += self.createOption( opt );
                }
            } )
            options += '</ul></li>';
        }
    } );

    var opts_el = '<div class="cs-options"><ul>' + options + '</ul></div>';

    this.selEl.innerHTML =
        '<span class="cs-placeholder">' + textContent( this.selectedOpt ) + ' <i></i></span>' + opts_el;
    // if parentNode present then we're performing DOM insertion
    if ( this.el.parentNode ) {
        this.el.parentNode.insertBefore( this.selEl, this.el );
    }
};

SelectMenu.prototype.createOption = function ( el ) {

    var optclass = '',
        classes = 'cs-option ',
        link = '',
        icon = '',
        iconTag = '';

    if ( el.selectedOpt && !this.foundSelected && !this.hasDefaultPlaceholder ) {
        classes += 'cs-selected ';
        this.foundSelected = true;
    }
    // extra classes
    if ( el.getAttribute( 'data-class' ) ) {
        classes += el.getAttribute( 'data-class' );
    }
    // link options
    if ( el.getAttribute( 'data-link' ) ) {
        link = 'data-link=' + el.getAttribute( 'data-link' );
    }
    // icon
    if ( el.getAttribute( 'data-icon' ) ) {
        icon += el.getAttribute( 'data-icon' );
    }
    if ( classes !== '' ) {
        optclass = 'class="' + classes + '" ';
    }

    if ( icon !== '' ) {
        iconTag = '<i class="icon-' + icon + '"></i> ';
    }

    return `<li ${optclass} ${link} data-option data-value="${el.value}">
        <span>${iconTag} ${textContent( el )}</span>
    </li>`;
};

SelectMenu.prototype.addOption = function ( label, value, appendToSelector ) {
    var option = document.createElement( 'option' ),
        ctx = (appendToSelector) ? this.el.querySelector( appendToSelector ) : this.el;

    option.value = value;
    textContent( option, label );
    ctx.appendChild( option );
    this._update();
};

SelectMenu.prototype._update = function () {
    // destroy
    this.destroy();
    // rebuild
    this._buildMenu();
};

SelectMenu.prototype._initEvents = function () {
    var self = this;

    // open/close select
    $( this.selPlaceholder ).on( 'click', function () {
        self._toggleSelect();
    } );

    // clicking the options
    this.selOpts.forEach( function ( opt, idx ) {
        $( opt ).on( 'click', function () {
            self.current = idx;
            self._changeOption();
            // close select elem
            self._toggleSelect();
        } );
    } );

    // close the select element if the target it´s not the select element or one of its descendants..
    $( document ).on( 'click', this.handleDocClick.bind( this ) );

    // keyboard navigation events
    $( this.selEl ).on( 'keydown', function ( ev ) {
        var keyCode = ev.keyCode || ev.which;

        switch ( keyCode ) {
            // up key
            case 38:
                ev.preventDefault();
                self._navigateOpts( 'prev' );
                break;
            // down key
            case 40:
                ev.preventDefault();
                self._navigateOpts( 'next' );
                break;
            // space key
            case 32:
                ev.preventDefault();
                if ( self._isOpen() && typeof self.preSelCurrent != 'undefined' && self.preSelCurrent !== -1 ) {
                    self._changeOption();
                }
                self._toggleSelect();
                break;
            // enter key
            case 13:
                ev.preventDefault();
                if ( self._isOpen() && typeof self.preSelCurrent != 'undefined' && self.preSelCurrent !== -1 ) {
                    self._changeOption();
                    self._toggleSelect();
                }
                break;
            // esc key
            case 27:
                ev.preventDefault();
                if ( self._isOpen() ) {
                    self._toggleSelect();
                }
                break;
        }
    } );
};

/**
 * Unbind events
 */
SelectMenu.prototype.destroy = function () {
    $( this.selEl ).off();
    $( this.selPlaceholder ).off();
    $( this.selOpts ).off();
    this.selOpts.forEach( function ( opt ) {
        $( opt ).off();
    } );
    $( document ).off( 'click', [this.handleDocClick] );
};

SelectMenu.prototype.handleDocClick = function ( ev ) {
    var target = ev.target;
    if ( this._isOpen() && target !== this.selEl && !hasParent( target, this.selEl ) ) {
        this._toggleSelect();
    }
};

/**
 * navigate with up/dpwn keys
 */
SelectMenu.prototype._navigateOpts = function ( dir ) {
    if ( !this._isOpen() ) {
        this._toggleSelect();
    }

    var tmpcurrent = typeof this.preSelCurrent !=
    'undefined' &&
    this.preSelCurrent !==
    -1 ?
        this.preSelCurrent :
        this.current;

    if ( dir === 'prev' && tmpcurrent > 0 || dir === 'next' && tmpcurrent < this.selOpts.length - 1 ) {
        // save pre selected current - if we click on option, or press enter, or press space this is going to be the index of the current option
        this.preSelCurrent = dir === 'next' ? tmpcurrent + 1 : tmpcurrent - 1;
        // remove focus class if any..
        this._removeFocus();
        // add class focus - track which option we are navigating
        $( this.selOpts[this.preSelCurrent] ).addClass( 'cs-focus' );
    }
};

/**
 * open/close select
 * when opened show the default placeholder if any
 */
SelectMenu.prototype._toggleSelect = function () {
    // remove focus class if any..
    this._removeFocus();

    if ( this._isOpen() ) {
        if ( this.current !== -1 && !this.options.permanentPlaceholder ) {
            // update placeholder text
            this.selPlaceholder.innerHTML = textContent( this.selOpts[this.current] ) + ' <i></i>';
        }
        $( this.selEl ).removeClass( 'cs-active' );
    }
    else {
        if ( this.hasDefaultPlaceholder && this.options.stickyPlaceholder ) {
            // everytime we open we wanna see the default placeholder text
            this.selPlaceholder.innerHTML = textContent( this.selectedOpt ) + ' <i></i>';
        }
//                classie.add( this.selEl, 'cs-active' );
        $( this.selEl ).addClass( 'cs-active' );
    }

};

SelectMenu.prototype._changeOption = function () {
    // if pre selected current (if we navigate with the keyboard)...
    if ( typeof this.preSelCurrent != 'undefined' && this.preSelCurrent !== -1 ) {
        this.current = this.preSelCurrent;
        this.preSelCurrent = -1;
    }

    // current option
    var opt = this.selOpts[this.current];

    // update current selected value
    if ( !this.options.permanentPlaceholder ) {
        this.selPlaceholder.innerHTML = textContent( opt ) + ' <i></i>';
    }

    // change native select element´s value
    this.el.value = opt.getAttribute( 'data-value' );

    // remove class cs-selected from old selected option and add it to current selected option
    var oldOpt = this.selEl.querySelector( 'li.cs-selected' );
    if ( oldOpt ) {
        $( oldOpt ).removeClass( 'cs-selected' );
    }
    $( oldOpt ).addClass( 'cs-selected' );

    // if there´s a link defined
    if ( opt.getAttribute( 'data-link' ) ) {
        // open in new tab?
        if ( this.options.newTab ) {
            window.open( opt.getAttribute( 'data-link' ), '_blank' );
        }
        else {
            window.location = opt.getAttribute( 'data-link' );
        }
    }

    // callback
    this.options.onChange( this.el.value );
};

SelectMenu.prototype._isOpen = function ( opt ) {
    return $( this.selEl ).hasClass( 'cs-active' );
};

SelectMenu.prototype._removeFocus = function ( opt ) {
    var focusEl = this.selEl.querySelector( 'li.cs-focus' )
    if ( focusEl ) {
        $( focusEl ).removeClass( 'cs-focus' );
    }
};

export default SelectMenu;
